import React from 'react'
import { Pulse } from './style'
import Tooltip from 'components/Tooltip'

const tooltipXOffset = 0
const tooltipYOffset = -16
const PulsingNotification = ({ number, element = 'accordion' }) => {
  return (
    <Tooltip
      style={{ zIndex: 1000 }}
      placement="top"
      trigger={['hover']}
      align={{ offset: [tooltipXOffset, tooltipYOffset] }}
      overlay={{ label: 'incompleteFields' }}
    >
      <Pulse element={element} id="pulse" data-testid='test-pulse-notification'>
        {number}
      </Pulse>
    </Tooltip>
  )
}

export default PulsingNotification
